var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAgregarFondoBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 9.91582H10.6375V6.74707C10.6375 6.63933 10.5947 6.536 10.5185 6.45981C10.4423 6.38362 10.339 6.34082 10.2312 6.34082C10.1235 6.34082 10.0201 6.38362 9.94396 6.45981C9.86778 6.536 9.82498 6.63933 9.82498 6.74707V9.91582H6.65623C6.54848 9.91582 6.44517 9.95862 6.36898 10.0348C6.29279 10.111 6.25 10.2143 6.25 10.3221C6.25 10.4298 6.29279 10.5331 6.36898 10.6093C6.44517 10.6855 6.54848 10.7283 6.65623 10.7283H9.82498V13.9033C9.82498 14.0111 9.86778 14.1144 9.94396 14.1906C10.0201 14.2668 10.1235 14.3096 10.2312 14.3096C10.339 14.3096 10.4423 14.2668 10.5185 14.1906C10.5947 14.1144 10.6375 14.0111 10.6375 13.9033V10.7283H13.8125C13.9202 10.7283 14.0236 10.6855 14.0998 10.6093C14.176 10.5331 14.2188 10.4298 14.2188 10.3221C14.2188 10.2143 14.176 10.111 14.0998 10.0348C14.0236 9.95862 13.9202 9.91582 13.8125 9.91582Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAgregarFondoBlanco);
export default __webpack_public_path__ + "static/media/ico_agregar-fondo-blanco.48c6706ce103d74b4646484392d17d19.svg";
export { ForwardRef as ReactComponent };